import { MenuIcon, StatsIcon } from './icons';
import { useStrings } from '../state/AppContext';

export interface HeaderProps {
  onMenu: () => void;
  onStats: () => void;
}

export function Header({ onMenu, onStats }: HeaderProps) {
  const t = useStrings();
  return (
    <header className="flex items-center justify-between px-1 pb-0 sm:pt-safe sm:pb-2">
      <button
        type="button"
        aria-label={t.common.menu}
        onClick={onMenu}
        className="grid h-11 w-11 place-items-center rounded-lg text-ink"
      >
        <MenuIcon className="h-6 w-6" />
      </button>

      <div className="relative">
        <span
          aria-hidden="true"
          className="absolute inset-0 -z-10 mx-auto h-8 w-32 rounded-full bg-grad-accent opacity-30 blur-2xl"
        />
        <h1 className="wordmark text-xl">LEXICON</h1>
      </div>

      <button
        type="button"
        aria-label={t.common.statistics}
        onClick={onStats}
        className="grid h-11 w-11 place-items-center rounded-lg text-ink"
      >
        <StatsIcon className="h-6 w-6" />
      </button>
    </header>
  );
}
